import Vue from 'vue'

/**
 * 权限指令
 * 用法: v-permission="'permissionKey'" 或 v-permission="['permissionKey1', 'permissionKey2']"
 */
Vue.directive('permission', {
  bind(el, binding, vnode) {
    checkPermission(el, binding, vnode)
  },
  update(el, binding, vnode) {
    checkPermission(el, binding, vnode)
  }
})

/**
 * 检查权限
 */
function checkPermission(el, binding, vnode) {
  // 获取用户权限
  const userPermissions = getUserPermissions()
  
  // 获取绑定的权限值
  const { value } = binding
  
  if (value) {
    let hasPermission = false
    
    if (typeof value === 'string') {
      // 单个权限
      hasPermission = userPermissions.includes(value)
    } else if (Array.isArray(value)) {
      // 多个权限，只要有一个就有权限
      hasPermission = value.some(permission => userPermissions.includes(permission))
    }
    
    // 如果没有权限，隐藏元素
    if (!hasPermission) {
      el.style.display = 'none'
    } else {
      el.style.display = ''
    }
  } else {
    console.warn('权限指令需要指定权限标识')
  }
}

/**
 * 获取用户权限
 */
function getUserPermissions() {
  try {
    // 从localStorage获取用户信息
    const userStr = localStorage.getItem('admin_user')
    if (userStr) {
      const user = JSON.parse(userStr)
      if (user.permissions) {
        return user.permissions
      }
    }
  } catch (error) {
    console.error('获取用户权限失败:', error)
  }
  
  // 如果localStorage中没有权限信息，返回空数组
  return []
}